<ng-template #modalMessage>
    <ep-modal-message></ep-modal-message>
</ng-template>
<ng-template #modalConfirm>
    <ep-modal-confirm></ep-modal-confirm>
</ng-template>
<ng-template #modalConfirmMultiButton>
    <ep-modal-confirm-multi-button></ep-modal-confirm-multi-button>
</ng-template>
<ng-template #modalSelectMultiChoice>
    <ep-modal-select-multi-choice></ep-modal-select-multi-choice>
</ng-template>
<ng-template #modalInput>
    <ep-modal-input></ep-modal-input>
</ng-template>
<ng-template #modalFile>
    <ep-modal-file-selector></ep-modal-file-selector>
</ng-template>
<ng-template #modalChangePassword>
    <ep-modal-change-password></ep-modal-change-password>
</ng-template>
<ng-template #modalDateTime>
    <ep-modal-datetime></ep-modal-datetime>
</ng-template>
<ng-template #modalJsonViewer>
    <ep-modal-json-viewer></ep-modal-json-viewer>
</ng-template>
